import { c as _c } from "react/compiler-runtime";
import type { MouseEvent } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@repo/blacksmith-ui/button";
import { cn } from "@repo/blacksmith-ui/cn";
import { STATUS_COLORS } from "@/components/filters/StatusFilter";
export const KEEP_GOING_ROUNDS = 3;
interface LoopLimitStripProps {
  headline: string;
  detail?: string;
  onKeepGoing?: (event: MouseEvent<HTMLButtonElement>) => void | Promise<void>;
  pending: boolean;
  continued: boolean;
  continuedHeadline: string;
  continuedDetail?: string;
  testId: string;
  tabIndex?: number;
  className?: string;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
}
export function LoopLimitStrip(t0) {
  const $ = _c(25);
  const {
    headline,
    detail,
    onKeepGoing,
    pending,
    continued,
    continuedHeadline,
    continuedDetail,
    testId,
    tabIndex,
    className,
    onClick
  } = t0;
  const displayedHeadline = continued ? continuedHeadline : headline;
  const displayedDetail = continued ? continuedDetail : detail;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-wrap items-center justify-between gap-x-3 gap-y-1.5 rounded-md border border-[var(--color-border)] bg-[var(--color-surface)] px-3 py-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = continued ? "var(--color-border)" : STATUS_COLORS.queued;
  let t3;
  if ($[2] !== t2) {
    t3 = <span aria-hidden={true} className="mt-[7px] size-1.5 shrink-0 rounded-full" style={{
      backgroundColor: t2
    }} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== displayedHeadline) {
    t4 = <p className="type-body-s-medium text-neutral-900 dark:text-neutral-100">{displayedHeadline}</p>;
    $[4] = displayedHeadline;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== displayedDetail) {
    t5 = displayedDetail ? <p className="type-body-xs-regular text-neutral-500 dark:text-neutral-400">{displayedDetail}</p> : null;
    $[6] = displayedDetail;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <div className="min-w-0">{t4}{t5}</div>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t6) {
    t7 = <div className="flex min-w-0 items-start gap-2">{t3}{t6}</div>;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== continued || $[15] !== onKeepGoing || $[16] !== pending || $[17] !== tabIndex) {
    t8 = !continued && onKeepGoing ? <Button type="button" disabled={pending} onClick={onKeepGoing} tabIndex={tabIndex} variant="secondary">{pending ? <Loader2 className="mr-1 size-3 animate-spin" /> : null}Keep going</Button> : null;
    $[14] = continued;
    $[15] = onKeepGoing;
    $[16] = pending;
    $[17] = tabIndex;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== onClick || $[20] !== t1 || $[21] !== t7 || $[22] !== t8 || $[23] !== testId) {
    t9 = <div className={t1} data-testid={testId} onClick={onClick}>{t7}{t8}</div>;
    $[19] = onClick;
    $[20] = t1;
    $[21] = t7;
    $[22] = t8;
    $[23] = testId;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
}